var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEmailIconBlue(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 13,
    viewBox: "0 0 12 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2060_764)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.00287 7.85204C6.70432 8.05107 6.35754 8.15628 6 8.15628C5.64248 8.15628 5.2957 8.05107 4.99716 7.85204L0.0798984 4.57376C0.0526172 4.55557 0.0260391 4.53661 0 4.51711V9.88892C0 10.5048 0.499805 10.9936 1.10468 10.9936H10.8953C11.5112 10.9936 12 10.4938 12 9.88892V4.51709C11.9739 4.53664 11.9473 4.55564 11.9199 4.57386L7.00287 7.85204Z",
    fill: "#2667B0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.469922 3.98897L5.38718 7.26727C5.57332 7.39137 5.78665 7.45341 5.99998 7.45341C6.21333 7.45341 6.42668 7.39135 6.61282 7.26727L11.5301 3.98897C11.8243 3.79292 12 3.46479 12 3.11065C12 2.50172 11.5046 2.00635 10.8957 2.00635H1.1043C0.495398 2.00637 0 2.50175 0 3.11124C0 3.46479 0.175687 3.79292 0.469922 3.98897Z",
    fill: "#2667B0"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2060_764"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12,
    height: 12,
    fill: "white",
    transform: "translate(0 0.5)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmailIconBlue);
export default __webpack_public_path__ + "static/media/email_icon_blue.d0d96b98ee42707020d8680cea9e271c.svg";
export { ForwardRef as ReactComponent };